import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from "@angular/router";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { LunaCommonModule } from "../common/common.module";
import { FooterComponent } from "./components/footer.component";
import { HeaderComponent } from "./components/header.component";
import { HomeComponent } from "./components/home.component";
import { SubHeaderComponent } from "./components/sub-header.component";
import { NavMenuComponent } from "./components/nav-menu.component";
import { BuildNumberService } from "./services/build-number.service";
import { NavigationService } from './services/navigation.service';
import { SubHeaderService } from "./services/sub-header.service";
import { CORE_ROUTES } from "./core.routes";
import { AuthRequiredComponent } from './components/auth-required.component';
import { DynamicDialogComponent } from './components/dynamic-dialog/dynamic-dialog.component';
import { DynamicDialogService } from "./services/dynamic-dialog.service";
import { SortSearchFilterHeaderComponent } from './components/sort-search-filter-header/sort-search-filter-header.component';
import { SelectOrganizationComponent } from './components/select-organization.component';
import { IdleTimeoutComponent } from './components/idle-timeout/idle-timeout.component';
import { CollapsibleComponent } from './components/collapsible/collapsible.component';

@NgModule({
imports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    LunaCommonModule,
    RouterModule.forChild(CORE_ROUTES)
  ],
  declarations: [
    FooterComponent,
    HeaderComponent,
    HomeComponent,
    SubHeaderComponent,
    NavMenuComponent,
    AuthRequiredComponent,
    DynamicDialogComponent,
    SortSearchFilterHeaderComponent,
    SelectOrganizationComponent,
    IdleTimeoutComponent,
    CollapsibleComponent
  ],
  providers: [
    BuildNumberService,
    NavigationService,
    SubHeaderService,
    DynamicDialogService,
    NavMenuComponent
  ],
  exports: [
    HeaderComponent,
    HomeComponent,
    FooterComponent,
    SubHeaderComponent,
    DynamicDialogComponent,
    SortSearchFilterHeaderComponent,
    IdleTimeoutComponent
  ]
})

export class LunaCoreModule { }
